import { render, staticRenderFns } from "./serverError.vue?vue&type=template&id=91876668&"
import script from "./serverError.vue?vue&type=script&lang=js&"
export * from "./serverError.vue?vue&type=script&lang=js&"
import style0 from "./serverError.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports